// Regular expressions to extract HTML metadata
const TITLE_REGEX = /<title[^>]*>([^<]+)<\/title>/;
const OG_TITLE_REGEX = /<meta[^>]*property="og:title"[^>]*content="([^"]+)"/;
const DESCRIPTION_REGEX = /<meta[^>]*name="description"[^>]*content="([^"]+)"/;
const OG_DESCRIPTION_REGEX = /<meta[^>]*property="og:description"[^>]*content="([^"]+)"/;
const OG_IMAGE_REGEX = /<meta[^>]*property="og:image"[^>]*content="([^"]+)"/;

// Interface representing the preview structure
export interface GlancifyPreview {
  title: string | null;
  description: string | null;
  image: string | null;
}

/**
 * Extracts metadata (title, description, image) from a given public URL.
 * @param url The URL of the page to analyze.
 * @returns An object containing the extracted metadata, or null values if not found.
 */
export const glancify = async (url: string): Promise<GlancifyPreview> => {
  const response = await fetch(url);

  // Check if the HTTP response is successful
  if (!response.ok) {
    throw new Error(`Failed to fetch URL: ${response.status} ${response.statusText}`);
  }

  const html = await response.text();

  // Match Open Graph title first, then fallback to <title> tag
  const titleMatch = html.match(OG_TITLE_REGEX) || html.match(TITLE_REGEX);

  // Match Open Graph description first, then fallback to meta description
  const descriptionMatch = html.match(OG_DESCRIPTION_REGEX) || html.match(DESCRIPTION_REGEX);

  // Match Open Graph image
  const imageMatch = html.match(OG_IMAGE_REGEX);

  return {
    title: titleMatch?.[1] ?? null,
    description: descriptionMatch?.[1] ?? null,
    image: imageMatch?.[1] ?? null,
  };
};
